import { PALETTE } from '../../common/styles/palette';
export const styles = (them: any) => {
    return {
        btnRoot: {
            backgroundColor: PALETTE.UI.Buttons.Background,
            color: 'white',
            height: '35px',
            marginTop: '20px',
            marginBottom: '5px',
            lineHeight: '0rem',
            paddingLeft: '0px',
            paddingRight: '0px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        btnRootWithIcon: {
            backgroundColor: PALETTE.UI.Buttons.Background,
            color: 'white',
            height: '30px',
            paddingLeft: '0px',
            paddingRight: '0px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        withIcon: {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
            paddingRight: '10px',
            //marginTop: '-5px'
        },
        withLeftIcon: {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
            paddingRight: '10px',
            marginTop: '-3px'
        },
        withRightIcon: {
            display: 'flex',
            alignItems: 'center',
            paddingRigth: '10px',
            paddingLeft: '10px',
            marginTop: '-3px'
        },
        iconButtonRoot: {
            borderRadius: '5px',
            backgroundColor: PALETTE.UI.Buttons.Background,
            padding: '10px',
            margin: '5px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        iconButtonRootSmall: {
            borderRadius: '3px',
            backgroundColor: PALETTE.UI.Buttons.Background,
            padding: '2px',
            margin: '5px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        iconButtonRootSvg: {
            borderRadius: '5px',
            backgroundColor: PALETTE.UI.Buttons.Background,
            padding: '0px',
            margin: '5px',
            width: '30px',
            height: '30px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        iconButtonRootSvgSecondary: {
            fill: PALETTE.UI.Buttons.Background,
            borderRadius: '5px',
            padding: '0px',
            margin: '5px',
            width: '30px',
            height: '30px',
            "&:hover": {
                fill: PALETTE.UI.Buttons.HoveredBackground,
            },
            "&:disabled": {
                fill: "transparent",
            }
        },
        iconButtonRootSvgBlack: {
            borderRadius: '5px',
            padding: '0px',
            margin: '5px',
            width: '30px',
            height: '30px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
                fill: "white"
            }
        },
        listIconButtonRootSvg: {
            padding: '0px',
            width: '15px',
            height: '15px',

        },
        listIconButtonSvg: {
            fill: PALETTE.UI.Buttons.Background,
            height: '15px',
            // "&:hover":{
            //     fill: PALETTE.UI.Buttons.HoveredBackground,
            //     backgroundColor: "transparent !important"
            // }
        },
        iconButtonSvg: {
            fill: PALETTE.White,
            height: '20px',
        },
        iconButtonSvgSecondary: {
            height: '20px',
        },
        iconButtonSvgBlack: {
            height: '20px',
            width: '20px',
        },
        iconButtonSvgSmall: {
            fill: PALETTE.White,
            height: '18px',
            width: '18px',
        },
        newItemIcon: {
            height: '25px',
            padding: '6px',
            fill: PALETTE.White
        },
        buttonItemIcon: {
            height: '22px',
            padding: '0px',
            fill: PALETTE.White,
            marginRight: '15px'
        },
        tabBtnRootUnselected: {
            backgroundColor: PALETTE.UI.Buttons.Tabbed.Selected.Background,
            color: 'white',
            marginTop: '20px',
            lineHeight: '0rem',
            paddingLeft: '0px',
            paddingRight: '0px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.Tabbed.Unselected.HoveredBackground,
                color: "#333"
            }
        },
        tabBtnRootSelected: {
            backgroundColor: PALETTE.UI.Buttons.Tabbed.Unselected.Background,
            color: 'white',
            marginTop: '20px',
            lineHeight: '0rem',
            paddingLeft: '0px',
            paddingRight: '0px',
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.Tabbed.Unselected.HoveredBackground,
                color: "#333"
            }
        },
        btnRootLabelWithIcon: {
            border: '1px solid ' + PALETTE.Primary,
            // color: PALETTE.UI.Buttons.Background,
            // height: '35px',
            // marginTop: '20px',
            // lineHeight: '0rem',
            // paddingLeft: '0px',
            // paddingRight: '0px',
            // alignItems: 'center',
            // justifyContent: 'center',
            // display: 'flex',
            display: 'inline-flex',
            marginLeft: 5,
            marginTop: 5,
            padding: '6px 8px'

        },
        labelButtonItemIcon: {
            height: 30,
            padding: 3,
            borderRadius: 6,
            fill: PALETTE.Primary,
            "&:hover": {
                backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            }
        },
        labelButtonItemIconDisabled: {
            height: 30,
            padding: 3,
            borderRadius: 6,
            fill: PALETTE.Primary,
        }
    }
}